import { Injectable } from "@angular/core";
@Injectable()
export class User {
    id: number;
    loginId: string;
    password: string;
    secondPassword: string;
     userType: any;
}
